import styled from 'styled-components';
import { Box } from './Box';

export const Container = styled(Box)`
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;
